import { bool } from "prop-types"
import { Navigate, useParams } from "react-router-dom"
import { useState, useEffect } from "react"
import AuthenticatedConfirmation from "./AuthenticatedConfirmation"
import GuestConfirmation from "./GuestConfirmation"
import { useSession } from "source/shared/hooks/useSession"
import { api } from "source/registrations/api/client"

const Confirmation = ({
  isNotificationShowing = false,
  isCancelation = false,
}) => {
  const { registrationId } = useParams()
  const {
    meta: { authenticated },
  } = useSession()
  const [shouldRedirectToLogin, setShouldRedirectToLogin] = useState(false)

  useEffect(() => {
    if (!authenticated) {
      api
        .post(
          `/registrations/v2/registrations/${registrationId}/check_event_guest_mode`,
          {},
        )
        .then((response) => {
          if (response?.errors) {
            const is404 = response.errors.some(
              (error) => error.status === "404" || error.code === 404,
            )
            if (is404) {
              setShouldRedirectToLogin(true)
              return
            }
          }

          const isWithinLastFiveMinutes = (timestamp) => {
            if (!timestamp) return false
            const createdAt = new Date(timestamp)
            const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000)
            return createdAt > fiveMinutesAgo
          }

          if (
            response?.data?.guestMode === "disabled" ||
            (response?.meta?.registrationCreatedAt &&
              !isWithinLastFiveMinutes(response.meta.registrationCreatedAt))
          ) {
            setShouldRedirectToLogin(true)
          }
        })
    }
  }, [authenticated, registrationId])

  if (shouldRedirectToLogin) {
    return <Navigate to={`/login?return=${window.location.href}`} replace />
  }

  return authenticated ? (
    <AuthenticatedConfirmation
      {...{ registrationId, isNotificationShowing, isCancelation }}
    />
  ) : (
    <GuestConfirmation />
  )
}

Confirmation.propTypes = {
  isNotificationShowing: bool,
  isCancelation: bool,
}

export default Confirmation
